import { useEffect, useState } from 'react';
import { authenticationService, useSearchParams } from '@lib/index';

export type ConfirmationStatus = 'loading' | 'success' | 'merge' | 'not_authorized';

const useConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<ConfirmationStatus>('loading');
  const [uname, setUname] = useState<string>('');

  useEffect(() => {
    const id = searchParams.get('id');
    const proof = searchParams.get('proof');

    const confirm = async () => {
      if (!id || !proof) {
        setStatus('not_authorized');
        return;
      }
      try {
        const response = await authenticationService.confirmEmail({ id, proof });
        const body = await response.json();
        setStatus(body.status as ConfirmationStatus);
        setUname(body.uname || '');
      } catch (error) {
        setStatus('not_authorized');
      }
    };

    confirm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { status, uname };
};

export default useConfirmEmail;
